import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  Item,
  ListView,
  ListViewProviderDirective,
  UIComponents
} from '@ntap/core';
import { first, map, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-odaberi-predmet',
  templateUrl: './odabir-predmeta.component.html'
})
export class OdabirPredmetaComponent implements OnInit, AfterViewInit {
  @Output()
  itemSelected = new EventEmitter<any[]>();

  @Input()
  itemPredmetId: number;

  @Input()
  currentViewName: string;

  @ViewChild(ListViewProviderDirective<ListView>)
  listViewProvider: ListViewProviderDirective<ListView>;

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  disabled$: Observable<boolean>;

  private selectedItems$: Observable<Item[] | null>;

  ngOnInit(): void {
    this.currentViewState = {
      $parent: { 'seup~predmet~id': this.itemPredmetId }
    };
    this.currentViewStateFilter = {};
  }

  public ngAfterViewInit(): void {
    this.selectedItems$ = this.listViewProvider.selectedItems$;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items);
          }
        })
      )
      .subscribe();
  }
}
